import * as R from 'ramda';

export interface I400Response {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors: any[];
  message: string;
}

interface IError {
  message?: string;
}

/**
 *
 * @description Мапит 400 ответ для корректного логирования в elk.
 */
export function map400Response(response: I400Response): string[] {
  if (!response.errors) {
    return [response.message];
  }

  return response.errors.reduce(
    (acc: string[], error: unknown) => {
      if (R.is(Object, error)) {
        const message = (error as IError).message;

        if (message) {
          acc.push(message);
        }
      }

      return acc;
    },
    [response.message],
  );
}
